import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.approval-forms.list', {
        url: '/list',
        component: 'requestCenterApprovalFormsList',
        resolve: {},
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/list/approval-forms-list.state.js